/*
https://codeseven.github.io/toastr/demo.html
https://github.com/CodeSeven/toastr
*/

import * as toastr from "toastr";

toastr.options = {
  progressBar: true,
  closeButton: true,
  positionClass: 'toast-bottom-left'
}

export function addWarning(title, message, onClick) {
  toastr.options.onclick = onClick;
  toastr.warning(message, title);
}

export function addSuccess(title, message, onClick) {
  toastr.options.onclick = onClick;
  toastr.success(message, title);
}

export function addError(title, message, onClick) {
  toastr.options.onclick = onClick;
  toastr.error(message, title);
}